var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwapped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#363636",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14 16c3.313 0 6-2.688 6-6 0-2.834-1.969-5.203-4.61-5.831l-1.05-3.144C14.139.413 13.567 0 12.92 0H3.08C2.434 0 1.862.413 1.66 1.025L.08 5.769C.028 5.922 0 6.08 0 6.244V14.5c0 .828.672 1.5 1.5 1.5H14zM9.766 5.75H8.75V1.5h4.169l.837 2.513c-1.556.062-2.96.709-3.99 1.737zm-2.516 0H1.666L3.08 1.5H7.25v4.25zM14 14.5c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zm-3.96 0H1.5V7.25h7.172C8.247 8.075 8 9.01 8 10c0 1.794.79 3.4 2.04 4.5z",
    transform: "translate(-41.000000, -235.000000) translate(0.000000, 1.000000) translate(16.500000, 54.000000) translate(25.250000, 177.000000) translate(0.000000, 3.250038)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363736",
    strokeWidth: 0.3,
    d: "M14.16 12.527c.114 0 .206-.094.206-.209v-.42c.608-.016 1.098-.534 1.098-1.173 0-.52-.334-.984-.813-1.13l-1.157-.351c-.133-.04-.226-.177-.226-.331 0-.19.136-.344.303-.344h.724c.117 0 .23.034.33.097.083.053.189.05.26-.019l.303-.292c.09-.088.085-.24-.015-.316-.234-.178-.517-.28-.807-.295v-.425c0-.115-.092-.208-.206-.208h-.412c-.113 0-.206.093-.206.208v.42c-.607.017-1.098.535-1.098 1.174 0 .52.334.984.813 1.13l1.158.35c.133.041.226.177.226.332 0 .19-.137.344-.304.344h-.723c-.118 0-.23-.034-.33-.097-.084-.053-.19-.05-.26.019l-.303.292c-.091.087-.086.24.014.316.235.177.517.28.808.295v.424c0 .115.092.209.206.209h.411z",
    transform: "translate(-41.000000, -235.000000) translate(0.000000, 1.000000) translate(16.500000, 54.000000) translate(25.250000, 177.000000) translate(0.000000, 3.250038)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapped);
export default __webpack_public_path__ + "static/media/swapped.a663283bdf04356537bcd275c429dea9.svg";
export { ForwardRef as ReactComponent };